import React from 'react';
import { connect } from 'react-redux';
import { UIAction } from 'redux/actions';
import {
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import { Link } from 'react-router-dom';
import DateRangePickerComp from 'components/DatePicker/DateRangePicker';
import moment from 'moment';
import {
  MdSearch, MdCampaign
} from 'react-icons/md';
import { checkPermissions } from 'hooks';
import DashboardWidget from '../../components/DashboardWidget';

const DashboardComponent = (props) => {

  const [campaignSearched, setCampaignSearched] = React.useState(false);
  const [postSearched, setPostSearched] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(props.activeTab);
  const [filter, setFilter] = React.useState(null);
  const [defaultRange] = React.useState(
    {
      startDate: moment().toDate(),
      endDate: moment().toDate(),
      key: 'selection'
    }
  );
  const [dateRange, setDateRange] = React.useState(defaultRange);
  const [widgetsList, setWidgetsList] = React.useState([]);
  const [adsWidgetsList, setAdsWidgetsList] = React.useState([]);


  const handleDateChange = (date) => {
    setDateRange(date);
  }

  React.useEffect(() => {
    (!campaignSearched || !postSearched) && handleSearch();
  }, [props.loginData, activeTab])


  const handleSearch = () => {
    const startDateString = dateRange.startDate ? moment(dateRange.startDate).format('YYYY-MM-DD') : '';
    const endDateString = dateRange.endDate ? moment(dateRange.endDate).format('YYYY-MM-DD') : '';
    const payload = { start_date: startDateString, end_date: endDateString };
    setFilter(payload);
    if (activeTab === 'POST') {
      setPostSearched(true);
    }
    if (activeTab === 'ADS') {
      setCampaignSearched(true);
    }
  }

  const handleTab = (tab) => {
    props.setDashboardActiveTab(tab);
  }

  React.useEffect(() => {
    setActiveTab(props.activeTab)
  }, [props.activeTab])

  React.useEffect(() => {
    let widgetSaved = [];
    if (props.widgetSaved && (props.widgetSaved).length > 0) {

      
      widgetSaved = props.widgetSaved;

      widgetSaved.forEach(element => {
        if (element.type === 'POST') {
          let selected = (element.widget_json) ? JSON.parse(element.widget_json) : [];
          setWidgetsList(selected);
        } else if (element.type === 'ADS') {
          let selected = (element.widget_json) ? JSON.parse(element.widget_json) : [];
          setAdsWidgetsList(selected);
        }
      })
    }
  }, [props.widgetSaved])

  return (
    <div>
      <DateRangePickerComp handleDateChange={handleDateChange} handleSearch={handleSearch} defaultRange={defaultRange} />
      <Link className={'manage-widget'} to={`/dashboard-widgets/${activeTab}`}>Manage Widgets</Link>
      <Nav tabs>
        {(checkPermissions(props.loginData, 'dashboard_data') || checkPermissions(props.loginData, 'google_analytics')
          || checkPermissions(props.loginData, 'google_analytics_graph') || checkPermissions(props.loginData, 'top_searches')) &&
          <NavItem>
            <NavLink
              className={(activeTab === 'POST') ? 'active' : ''}
              onClick={() => handleTab('POST')} >
              <MdSearch style={{ color: '#3aacd6', marginRight: 10, fontSize: 25 }} /> Users and Searches
            </NavLink>
          </NavItem>
        }
        {(checkPermissions(props.loginData, 'campaign_analytics') && (process.env.REACT_APP_VERSION && process.env.REACT_APP_VERSION !== '1.0.0')) &&
          <NavItem>
            <NavLink
              className={(activeTab === 'ADS') ? 'active' : ''}
              onClick={() => handleTab('ADS')} >
              <MdCampaign style={{ color: '#3aacd6', marginRight: 10, fontSize: 25 }} /> Campaigns
            </NavLink>
          </NavItem>
        }
      </Nav>
      <TabContent activeTab={activeTab} style={{ paddingTop: 30 }}>
        <TabPane tabId="POST">
          {
            (widgetsList && widgetsList.length > 0) ? widgetsList.map((item) => {
              return (<DashboardWidget key={item.id} id={item.id} filter={filter} />)
            })
              : <div className='manage-widget-btn'>
                <Link style={{ float: 'none' }} className={'manage-widget'} to={`/dashboard-widgets/${activeTab}`}>Manage Your Dashboard</Link>
              </div>
          }
        </TabPane>
        <TabPane tabId="ADS">
          {
            (adsWidgetsList && adsWidgetsList.length > 0) ? adsWidgetsList.map((item) => {
              return (<DashboardWidget key={item.id} id={item.id} filter={filter} />)
            })
              : <div className='manage-widget-btn'>
                <Link style={{ float: 'none' }} className={'manage-widget'} to={`/dashboard-widgets/${activeTab}`}>Manage Your Dashboard</Link>
              </div>
          }
        </TabPane>
      </TabContent>
    </div>
  );
}

const mapStateToProps = (state) => ({
  loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
  activeTab: (state.uiReducer && state.uiReducer.activeTab) ? state.uiReducer.activeTab : 'POST',
});
const mapDispatchToProps = (dispatch) => ({
  setDashboardActiveTab: (payload) => dispatch(UIAction.setDashboardActiveTab(payload)),
})
export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);



